<template>
  <q-chip
    :color="useQuasarColor ? chipColor : undefined"
    :text-color="useQuasarColor ? 'white' : undefined"
    :size="size"
    :dense="dense"
    :icon="showIcon ? chipIcon : undefined"
    :class="chipClasses"
  >
    <slot>{{ label }}</slot>
  </q-chip>
</template>

<script setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import {
  formatSalePaymentMethod,
  getPaymentMethodChipClasses,
  getPaymentMethodColor,
  getPaymentMethodIcon,
  usesCustomTabChipStyle
} from '@/utils/saleDisplay'

const props = defineProps({
  method: {
    type: String,
    default: ''
  },
  tabPurpose: {
    type: String,
    default: null
  },
  size: {
    type: String,
    default: '0.75rem'
  },
  dense: {
    type: Boolean,
    default: false
  },
  showIcon: {
    type: Boolean,
    default: true
  }
})

const { t } = useI18n()

const label = computed(() => formatSalePaymentMethod(t, props.method, {
  tabPurpose: props.tabPurpose
}))
const chipColor = computed(() => getPaymentMethodColor(props.method))
const chipIcon = computed(() => getPaymentMethodIcon(props.method, props.tabPurpose))
const useQuasarColor = computed(() => !usesCustomTabChipStyle(props.method))
const chipClasses = computed(() => [
  'payment-method-chip',
  ...getPaymentMethodChipClasses(props.method, props.tabPurpose)
])
</script>

<style lang="scss" scoped>
@import '../../css/variables.scss';

.payment-method-chip {
  font-size: 0.8rem;
  padding: $spacing-xs $spacing-sm;
}
</style>
